<script>
import CustomDialog from "@/components/_Shared/Dialog";
import InputGroup from "@/components/_Shared/InputGroup";

import { mapState, mapActions } from "vuex";

import errorMixin from "@/mixins/errorMixin";
import freshDesk from "@/utils/freshDesk";

export default {
  mixins: [errorMixin],
  data() {
    return {
      email: "",
      loader: false
    };
  },
  components: {
    CustomDialog,
    InputGroup
  },
  computed: {
    ...mapState("user", ["user", "showEmailNotVerifiedDialog"]),

    isSameAsTheStoreEmail() {
      return this.email === this.user.email;
    },

    visible() {
      return (
        this.showEmailNotVerifiedDialog &&
        this.user.status === "waiting_email_verification"
      );
    }
  },
  methods: {
    ...mapActions("user", [
      "closeEmailNotVerifiedDialog",
      "checkEmail",
      "refreshUser"
    ]),

    verifyEmail() {
      if (!this.isSameAsTheStoreEmail) {
        this.createError(
          "email",
          `O email cadastrado foi <b>${
            this.user.email
          }</b>. Caso o seu e-mail não seja esse, solicite a alteração clicando no botão abaixo.`
        );
        throw "Ops! Verifique os dados informados";
      }
    },

    async send() {
      this.loader = true;

      try {
        await this.verifyEmail();
        await this.checkEmail(this.email);
        this.closeEmailNotVerifiedDialog();
        await this.refreshUser();
        this.$toasted.success("O e-mail foi confirmado!");
      } catch (e) {
        this.$toasted.error(e);
      }

      this.loader = false;
    },

    openFreshdesk() {
      freshDesk.open("ticketForm");
    }
  }
};
</script>

<template>
  <custom-dialog icon="/static/mail-purple.svg" title="Verifique seu e-mail!" :visible="visible">
    <p slot="header">Informe seu e-mail abaixo para prosseguir com a compra.</p>

    <template slot="body">
      <input
        v-model="email"
        type="email"
        name="email"
        placeholder="informe o e-mail cadastrado"
        v-validate="'required|email'"
        :class="{'has-error': errors.has('email')}"
        @keyup.enter="send"
      />
      <small v-if="errors.has('email')" v-html="errors.first('email')"></small>

      <div class="btn-group mt-10">
        <div class="btn bg-purple-outline" @click="openFreshdesk()">solicitar alteração</div>
        <div class="btn bg-purple" :class="{'btn--loading': loader}" @click="send">
          <span>confirmar e-mail</span>
        </div>
      </div>
    </template>
  </custom-dialog>
</template>

<style scoped>
input {
  text-align: left;
  color: var(--purple);
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  padding: 0 10px;
  text-align: center;
  width: 260px;
  max-width: calc(100% - 60px);
}

input.has-error {
  border-color: var(--pink-off-white);
  color: var(--pink);
}

p {
  margin-top: 0;
}

small {
  margin-top: 10px;
  color: var(--pink);
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Warnings/EmailNotVerified/Dialog.vue